import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Sprout } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function Logo({ onClick }) {
  return (
    <Link to="/" onClick={onClick} className="flex items-center gap-2" data-testid="nav-logo">
      <span className="grid place-items-center w-9 h-9 rounded-xl" style={{ background: "var(--sage-tint)" }}>
        <Sprout size={20} style={{ color: "var(--sage)" }} />
      </span>
      <span className="font-serif text-[20px] font-semibold" style={{ color: "var(--text)" }}>
        Decode<span style={{ color: "var(--accent-strong)" }}>Kid</span>
      </span>
    </Link>
  );
}

const links = [
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
  { to: "/safety", label: "Safety" },
  { to: "/faq", label: "FAQ" },
  { to: "/about", label: "About" },
];

export default function PublicNav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  return (
    <header className="sticky top-0 z-50 dk-raised backdrop-blur-md" style={{ background: "rgba(250,249,245,.9)" }} data-testid="nav-header">
      <div className="dk-container flex items-center justify-between h-16">
        <Logo />
        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
              className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors hover:bg-[#E5E2DC] ${loc.pathname === l.to ? "text-[#B04A39]" : "text-[#2F3A34]"}`}>
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-2">
          {user ? (
            <button className="btn btn-primary" onClick={() => nav("/app")} data-testid="nav-app-btn">Go to app</button>
          ) : (
            <>
              <button className="btn btn-ghost" onClick={() => nav("/auth/login")} data-testid="nav-login-btn">Log in</button>
              <button className="btn btn-primary" onClick={() => nav("/auth/signup")} data-testid="nav-signup-btn">Try 3 days free</button>
            </>
          )}
        </div>
        <button className="md:hidden btn btn-ghost px-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden dk-container pb-4 flex flex-col gap-1 anim-in">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="px-3 py-3 rounded-lg font-medium hover:bg-[#E5E2DC]">{l.label}</Link>
          ))}
          <div className="flex gap-2 mt-2">
            {user ? (
              <button className="btn btn-primary flex-1" onClick={() => nav("/app")}>Go to app</button>
            ) : (
              <>
                <button className="btn btn-outline flex-1" onClick={() => nav("/auth/login")}>Log in</button>
                <button className="btn btn-primary flex-1" onClick={() => nav("/auth/signup")}>Try free</button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
